export default __webpack_public_path__ + "static/media/NokiaKokia.e16f408e.ttf";